module.exports = __webpack_public_path__ + "static/media/dolly-icon.df46f960.svg";